import { assert_array_is_empty } from '@shared/asserts/utils_asserts';
import { slice_actions } from '../store_slices';
import { ENUM__redux_action } from './ENUM__redux_action';
import { ENUM__redux_slice } from './ENUM__redux_slice';

export function validate_redux_actions() {
  const missing_actions_in_store: Record<string, string> = {};

  for (const slice_full_name of Object.values(ENUM__redux_action)) {
    let [slice_name, action_name] = slice_full_name.split('/');

    if (slice_name == ENUM__redux_slice.PERSIST || slice_name == ENUM__redux_slice.GLOBAL) continue;

    if (slice_full_name in slice_actions) continue;

    missing_actions_in_store[slice_full_name] = slice_full_name;
  }

  assert_array_is_empty(Object.values(missing_actions_in_store), missing_actions_in_store);

  const missing_actions_in_enum: Record<string, string> = {};

  for (const action_name of Object.keys(slice_actions)) {
    if (Object.values(ENUM__redux_action).includes(action_name)) continue;

    missing_actions_in_enum[action_name] = action_name;
  }

  assert_array_is_empty(Object.values(missing_actions_in_enum), missing_actions_in_enum);
}
